/* eslint-disable */
export const ru = {
    'QR код': 'QR-код',
    Бейдж: 'Бейдж',
    'Виджет с картой': 'Виджет с картой',
    Кнопка: 'Кнопка',
    Ссылка: 'Ссылка',
    'widgetgenerator.erip.tooltip':
        "Это особый код, создаваемый для маркировки каждой рекламы в интернете. Он является открытым, то есть доступным для всех пользователей в сети, и размещается в параметрах ссылки. Получить ERID можно в <a href='https://distribution.yandex.ru/v2/create/partner/go?utm_source=widget_generator'>личном кабинете</a>  Яндекс Дистрибуции",
    'widgetgenerator.legal.url.yandex': 'https://yandex.ru/legal/taxi_api',
    'widgetgenerator.legal.url.yango': 'https://yandex.com/legal/taxi_api',
    'widgetgenerator.modal.continue': 'Продолжить',
    'widgetgenerator.modal.message':
        'Тип виджета "Виджет с картой" не поддерживается для веденного адреса, пожалуйста используйте другой формат виджета',
    'widgetgenerator.yandex.badge.orderInYandex': 'Заказать в Яндекс Go',
    'widgetgenerator.yandex.defaultAddress': 'Москва, Россия, улица Льва Толстого, 16',
    'widgetgenerator.yango.badge.getRidetitle': 'Вызвать такси',
    'widgetgenerator.yango.badge.orderInYango': 'Заказать в Yango',
    'widgetgenerator.yango.defaultAddress':
        'Дейра, эмират Дубай, Объединенные Арабские Эмираты, Дубаи Интернешнл Эйрпорт',
    Адрес: 'Адрес',
    'Адрес сайта или CLID партнерской программы': 'Адрес сайта или CLID партнерской программы',
    'Без адреса': 'Без адреса',
    Бизнес: 'Business',
    'Введите авторизационные данные для доступа к API. Получить их можно':
        'Введите авторизационные данные для доступа к API. Получить их можно',
    'Вызвать такси': 'Вызвать такси',
    'Генератор виджета': 'Генератор виджета',
    'Доехать на такси': 'Доехать на такси',
    Заголовок: 'Заголовок',
    Загрузить: 'Загрузить',
    Комфорт: 'Комфорт',
    Копировать: 'Копировать',
    Куда: 'Куда',
    'Маршрут, встроенный в ссылку': 'Маршрут, встроенный в ссылку',
    Минивен: 'Минивэн',
    'Нажимая «Получить код» вы соглашаетесь с': 'Нажимая «Получить код» вы соглашаетесь с',
    'Невозможно выбрать тариф: регион не поддерживается':
        'Невозможно выбрать тариф: регион не поддерживается',
    'Неправильный адрес': 'Неправильный адрес',
    'Новый виджет': 'Новый виджет',
    Откуда: 'Откуда',
    Подзаголовок: 'Подзаголовок',
    'Получить код': 'Получить код',
    'Скачать QR код': 'Скачать QR-код',
    'Скопируйте код и установите на сайте': 'Скопируйте код и установите на сайте',
    Стиль: 'Стиль',
    Стоимость: 'Стоимость',
    Тариф: 'Тариф',
    'Текст успешно скопирован': 'Текст успешно скопирован',
    'Указанный адрес': 'Указанный адрес',
    'Фоновое изображение': 'Фоновое изображение',
    Цена: 'Цена',
    Эконом: 'Эконом',
    'Это поле обязательно': 'Это поле обязательно',
    'оставив заявку': 'оставив заявку',
    'условиями использования': 'условиями использования',
};
